<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="3">
            <material-card v-if="!passwordRequested">
              <p class="headline primary--text">Solicite nova senha</p>              
              <v-form ref="form" lazy-validation>
                <v-col cols="12">
                  <custom-input-mask                
                    ref="user"
                    id="user"
                    autofocus
                    :rules="requiredRule"
                    label="CPF"
                    :mask="['###.###.###-##']"
                    prepend-icon="mdi-account-key"
                    v-model="auth.cpf"
                  ></custom-input-mask>                  
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn block @click="submit()" color="primary">Solicitar</v-btn>
                </v-col>           
                <v-col cols="12" class="text-right" color="info">
                  <a @click="goToLogin()" class="primary--text">Acessar Sistema</a>                  
                </v-col>     
              </v-form>
            </material-card>
            <material-card v-else color="nav">
              <p class="headline primary--text">Requisição realizada com sucesso</p>                            
              <p class="body-2">Um email foi enviado com os próximos passos. Acesse seu email para finalizar a alteração da senha</p>              
              <v-btn to="/login" block color="primary">Voltar para login</v-btn>
            </material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import rules from "../../utils/rules";
import CustomInputMask from "@/components/shared/CustomInputMask";

export default {
  mixins: [rules],
  components: {
    CustomInputMask
  },
  data() {
    return {
      auth: {
        cpf: ""        
      },
      passwordRequested: false
    };
  },
  methods: {
    ...mapActions("auth", ["solicitarNovaSenha"]),        
    goToLogin() {
        this.$router.push({ name: "Login" });
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.solicitarNovaSenha(this.auth.cpf).then(() => {
          this.passwordRequested = true;
        });
      }
    }
  }
};
</script>
